import React, { useEffect, useState } from 'react';
import { ResourceField, ResourceFormPage } from '../../components/resource/ResourceFormPage';
import { ContagemEstoqueDiaria } from '../../types/estoque';
import {
  armazensService,
  catalogoProdutosService,
  contagensEstoqueService,
} from '../../services';
import { makeOptionLoader } from '../../utils/optionLoaders';

const produtoOptionLoader = makeOptionLoader(
  catalogoProdutosService.list,
  (item) => `${item.codigo ?? item.id} - ${item.descricao ?? ''}`.trim(),
);

const armazemOptionLoader = makeOptionLoader(
  armazensService.list,
  (item) => item.nome ?? `Armazém ${item.id}`,
);

const fields: ResourceField<ContagemEstoqueDiaria>[] = [
  {
    name: 'produto',
    label: 'Produto',
    type: 'async-select',
    valueType: 'number',
    loadOptions: produtoOptionLoader,
    required: true,
    showSearchControl: false,
  },
  {
    name: 'armazem',
    label: 'Armazém',
    type: 'async-select',
    valueType: 'number',
    loadOptions: armazemOptionLoader,
    required: true,
    showSearchControl: false,
  },
  {
    name: 'data_contagem',
    label: 'Data da contagem',
    type: 'date',
    required: true,
  },
  {
    name: 'quantidade_contada',
    label: 'Quantidade contada',
    type: 'number',
    valueType: 'number',
    required: true,
  },
];

export const ContagensDiariasFormPage: React.FC = () => {
  const today = new Date().toISOString().split('T')[0];
  const [initialValues, setInitialValues] = useState<Record<string, unknown>>({
    data_contagem: today,
  });

  useEffect(() => {
    let mounted = true;
    armazensService
      .list({ page_size: 20 })
      .then((response) => {
        const firstArmazem = response.results?.[0];
        if (mounted && firstArmazem) {
          setInitialValues((prev) => ({ ...prev, armazem: firstArmazem.id }));
        }
      })
      .catch(() => {
        /* ignore */
      });
    return () => {
      mounted = false;
    };
  }, []);

  return (
    <ResourceFormPage
      title="Contagem diária de estoque"
      description="Registre a quantidade física por produto na data selecionada."
      fields={fields}
      service={contagensEstoqueService}
      redirectPath="/admin/producao/contagens-diarias"
      cancelPath="/admin/producao/contagens-diarias"
      initialValues={initialValues}
    />
  );
};
